export default {
    mutateCommonProperties ({ commit }, payload) {
      // console.log('mutateCommonProperties === commit=', commit, 'payload=', payload)
      commit('mutateCommonProperties', payload)
    },
    AuthUser ({ commit }, payload) {
      commit('AuthUser', payload)
    },
    studyGroups ({ commit }, payload) {
      commit('studyGroups', payload)
    },
    userEnrollment ({ commit }, payload) {
      commit('userEnrollment', payload)
    },
    userAssessmentCompleted ({ commit }, payload) {
      commit('userAssessmentCompleted', payload)
    },
    setBellNotifications ({ commit }, payload) {
      commit('setBellNotifications', payload)
    },
    logoutLoading ({ commit }, payload) {
      commit('logoutLoading', payload)
    },
    setList ({ commit }, payload) {
      commit('setList', payload)
    },
    resetList ({ commit }) {
      commit('resetList', [])
    },
    removeItemFromSetList ({ commit }, payload) {
      commit('removeItemFromSetList', payload)
    },
    toggleStatus ({ commit }, payload) {
      commit('toggleStatus', payload)
    },
    toggleDropdownItemStatus ({ commit }, payload) {
      commit('toggleDropdownItemStatus', payload)
    },
    resetState ({ commit }) {
      commit('resetState')
    },
    setNotification ({ commit }, payload) {
      commit('setNotification', payload)
    }
  }
